import React, { useEffect, useState } from 'react';
import { adminTeacher, getPaper, logDownload, errMsg } from './aiPaperApi';
import FileTable from './FileTable';
import PaperSheet from './PaperSheet';
import { SHEET_W } from './sheetStyles';
import { downloadSheetPdf, safeFileName } from './exportUtils';
import { ui } from './ui';

const fmt = (d) => (d ? new Date(d).toLocaleString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-');

// Principal view of one teacher: generated papers (one-click PDF / answer key) + original uploads.
function TeacherDetail({ user, teacher }) {
  const [detail, setDetail] = useState(null);
  const [err, setErr] = useState('');
  const [job, setJob] = useState(null); // { paper, mode }

  useEffect(() => {
    setDetail(null); setErr('');
    adminTeacher(user, teacher.key).then(setDetail).catch((e) => setErr(errMsg(e)));
  }, [user, teacher.key]);

  const startPdf = async (id, mode) => {
    try { setJob({ paper: await getPaper(user, id), mode }); } catch (e) { setErr(errMsg(e)); }
  };

  // Hidden full-size sheet is mounted first, then exported.
  useEffect(() => {
    if (!job) return undefined;
    const t = setTimeout(async () => {
      try {
        const { paper, mode } = job;
        await downloadSheetPdf(document.getElementById('pm-export'),
          `${safeFileName(paper.subject)}_Class${safeFileName(paper.class)}_${mode === 'key' ? 'ANSWER_KEY' : 'Question_Paper'}.pdf`);
        logDownload(user, paper._id, mode);
      } catch (e) { setErr(errMsg(e)); }
      setJob(null);
    }, 300);
    return () => clearTimeout(t);
  }, [job, user]);

  return (
    <div style={{ marginTop: 18 }}>
      <h3 style={{ color: '#312e81', margin: '0 0 8px' }}>{teacher.teacherName}</h3>
      {err && <div style={ui.errorBox}>{err}</div>}
      {!detail ? <div>Loading…</div> : (
        <>
          <div style={ui.label}>Generated papers ({detail.papers.length}) · 🎨 = style-cloned</div>
          {detail.papers.length === 0 && <div style={{ fontSize: 13, color: '#64748b' }}>None.</div>}
          {detail.papers.map((p) => (
            <div key={p._id} style={ui.listRow}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, fontSize: 13 }}>{p.title}{p.styleCloned ? ' 🎨' : ''}</div>
                <div style={{ fontSize: 11, color: '#64748b' }}>Class {p.class} · {p.subject} · {fmt(p.createdAt)} · {p.downloadCount || 0} downloads</div>
              </div>
              <button style={ui.btnSmall} disabled={!!job} onClick={() => startPdf(p._id, 'question')}>⬇ Paper</button>
              <button style={{ ...ui.btnSmall, color: '#b91c1c' }} disabled={!!job} onClick={() => startPdf(p._id, 'key')}>🔒 Key</button>
            </div>
          ))}
          <div style={{ ...ui.label, marginTop: 14 }}>Uploaded files ({detail.files.length})</div>
          <FileTable user={user} files={detail.files} />
        </>
      )}
      {job && (
        <div style={{ position: 'absolute', left: -99999, top: 0, width: SHEET_W }} aria-hidden="true">
          <PaperSheet id="pm-export" paper={job.paper} mode={job.mode} logoSrc="/logo.png" />
        </div>
      )}
    </div>
  );
}

export default TeacherDetail;
